/**
 * Created by mgoria on 8/04/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingActionException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when requested resource action not found
 */
let MissingActionException = exports.MissingActionException = function (_Exception) {
  _inherits(MissingActionException, _Exception);

  /**
   * @param {String} resourceName
   * @param {String} actionName
   */
  function MissingActionException(resourceName, actionName) {
    _classCallCheck(this, MissingActionException);

    return _possibleConstructorReturn(this, (MissingActionException.__proto__ || Object.getPrototypeOf(MissingActionException)).call(this, `Missing action ${actionName} in ${resourceName} resource.`));
  }

  return MissingActionException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/MissingActionException.js
// module id = 419
// module chunks = 0